import Timer from "../../../assets/images/assessment_instruction/timer.png";
import Minutes from "../../../assets/images/assessment_instruction/minutes.png";
import Abcd from "../../../assets/images/assessment_instruction/abcd.png";
import Flag from "../../../assets/images/assessment_instruction/flag.png";
import Report from "../../../assets/images/assessment_instruction/report.png";
import Submit from "../../../assets/images/assessment_instruction/submit.png";
import Headphone from "../../../assets/images/assessment_instruction/webcam.svg";
import Invalid from "../../../assets/images/assessment_instruction/invalid.png";

export const instructionList = [
  {
    image: Minutes,
    text: (
      <>
        Please ensure you are in a <b>quiet environment.</b>
      </>
    ),
  },
  {
    image: Submit,
    text: (
      <>
        When you <b>run out of time</b> the assessment will be auto submitted
      </>
    ),
  },
  {
    image: Abcd,
    text: (
      <>
        Each question may have <b>one or more suitable answers</b>
      </>
    ),
  },
  {
    image: Report,
    text: (
      <>
        Your <b>assessment report details</b> will be emailed to you
      </>
    ),
  },
  {
    image: Timer,
    text: (
      <>
        You will be provided with <b>indicative time</b> against each question
      </>
    ),
  },
  {
    image:Headphone,
    text: (
      <>
        Ensure that <b>Camera, Headphone & Microphone</b> are always on
      </>
    ),
  },
  {
    image: Flag,
    text: (
      <>
        You will have an <b>option to re-visit the question</b> later
      </>
    ),
  },
  {
    image: Invalid,
    text: (
      <>
        Your assessment <b>will be invalidated</b> if you tab out or close the
        browser
      </>
    ),
  },
];

